import React from 'react';
import './Header.scss';

interface HeaderProps {

  errorMessage?: string | null
}

const Header: React.FC<HeaderProps> = ({errorMessage}) => {

  const showContent = location.pathname === '/' || '/forgotusername' || '/customer/forgot/username';

  return (
    <header className="hcsc-banner">
      <img className="hs-logo" src="/static/svgs/logos/healthspring-logo.svg" alt="HealthSpring logo"/>
      {errorMessage && <div className='enterpise-not-found'>Account Not found</div>}

    </header>

  );
};

export default Header;
